import Text from 'components/Text/Text';
import './CountryWordTooltip.scss';

interface ICountryWordTooltipProps {
  countryName: string;
}

const CountryWordTooltip = ({countryName}: ICountryWordTooltipProps) => {
  return (
    <div className="country-word-tooltip" role="tooltip">
      <Text tag="p">{countryName}</Text>
    </div>
  );
};

export default CountryWordTooltip;
